import { render, staticRenderFns } from "./PlatformEntity.vue?vue&type=template&id=022188a0&"
import script from "./PlatformEntity.vue?vue&type=script&lang=js&"
export * from "./PlatformEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports